import { render } from "./RoleModulePage.vue?vue&type=template&id=34b69838&ts=true"
import script from "./RoleModulePage.vue?vue&type=script&lang=ts"
export * from "./RoleModulePage.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__